import { ROUTES } from "@/constants/routes";
import { useAppNavigate } from "@/hooks/pane-routing";
import { emitCanvasAddEntity } from "@/pages/canvas/hooks/useCanvasWindowEvents";
import { openEntityInDetailPane } from "@/pages/canvas/utils/openNodeInDetailPane";
import type { Entity } from "@cohesive/ui-components";
import { getEntityName } from "@cohesive/ui-components";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useMatch } from "react-router-dom";

export function useConnectorEntitySelect() {
  const appNavigate = useAppNavigate();
  const isCanvasDetail = useMatch(ROUTES.CANVAS.DETAIL);

  return useCallback(
    (entity: Entity) => {
      if (isCanvasDetail) {
        emitCanvasAddEntity(entity);
        toast.success(`Added ${getEntityName(entity)} to canvas`, {
          duration: 2000,
          icon: "✓",
        });
        return;
      }

      openEntityInDetailPane(entity, appNavigate);
    },
    [appNavigate, isCanvasDetail],
  );
}
